import apolloClient from '../apolloClient';
import getScheduleQuery from '@custom/core/apollo/graphql/getSchedule.graphql';
import { GetUniversalHeadlines } from '@root/modules/headlines/types/headlines';

interface Variables {
  dateStart: string;
  dateEnd: string;
  offset: number;
  limit: number;
}

export interface GetScheduleResponse {
  data: GetUniversalHeadlines['data'];
}

const getSchedule = async (variables: Variables) => {
  const queryOptions = { variables };
  const options = Object.assign({ query: getScheduleQuery }, queryOptions);

  const { data }: GetScheduleResponse = await apolloClient.query(options);

  return data;
};

export default getSchedule;
